import { Component, OnInit, Input, Pipe, PipeTransform } from '@angular/core';
import { DetalleLiquidacion } from 'app/view/impo/impo';

@Pipe({
    name: 'pointDd'
})

export class pointDd implements PipeTransform {
    transform(value: string, args: any[]): string {
        if (value) {
            return value.replace(',', '.');
        }
        return '';
    }
}

@Component({
    moduleId: module.id,
    selector: 'detalle-liquidar',
    templateUrl: './detalle.component.html'
})

export class DetalleComponent implements OnInit {
    eid: number;

    constructor() {
        this.eid = 1;
    }

    @Input() detalleLiquidacion: DetalleLiquidacion;
    @Input() detalleDescrip: {};
    @Input() totalDD: number;


    ngOnInit() { }
}


// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/modulo_compartido/detalle_liquidacion/detalle.component.ts